/**
 * Product card listener (V4: delegate via EventScope)
 */

import { getEventScope } from "../../core/event-scope/event-scope";
import { Roles } from "../../constants/roles";

type ProductCardLikeHandler = {
    handleLike: (btn: HTMLElement) => Promise<void>;
};

type ProductCardListenerOptions = {
    onResize?: (() => void) | null;
    onListZoomToggle?: (() => void) | null;
};

class ProductCardListener {
    public handler: ProductCardLikeHandler;

    public onResize: (() => void) | null;

    public onListZoomToggle: (() => void) | null;

    public constructor(handler: ProductCardLikeHandler, options?: ProductCardListenerOptions) {
        this.handler = handler;
        this.onResize = options?.onResize || null;
        this.onListZoomToggle = options?.onListZoomToggle || null;
    }

    public setup(): void {
        const scope = getEventScope(document, "product-card");

        scope.once("product-card-like", () => {
            scope.delegate("click", `[data-role="${Roles.PRODUCT_LIKE_BTN}"]`, async (event, buttonElement) => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                if (!(buttonElement instanceof HTMLElement)) {
                    return;
                }
                await this.handler.handleLike(buttonElement);
            });
        });

        if (this.onResize) {
            scope.once("product-card-resize", () => {
                window.addEventListener(
                    "resize",
                    () => {
                        this.onResize?.();
                    },
                    { passive: true },
                );
            });
        }

        if (this.onListZoomToggle) {
            scope.once("product-card-list-image-zoom-toggle", () => {
                scope.delegate("change", `[data-role="${Roles.PRODUCT_LIST_IMAGE_ZOOM_TOGGLE}"]`, () => {
                    this.onListZoomToggle?.();
                });
            });
        }
    }
}

export { ProductCardListener };
